/**
 * Постоянная ссылка на установщик для Windows — последняя вышедшая версия.
 *
 * Релизы лежат в приватном airel-frontend, поэтому качают их не с GitHub, а со
 * стенда: служба `desktop-mirror` (airel-rs) держит там последний релиз, и
 * `Airel-Setup.exe` всегда указывает на него. Путь относительный — кнопка
 * есть только в веб-версии, а её отдаёт тот же адрес.
 */
export const DESKTOP_DOWNLOAD = "/desktop/electron/Airel-Setup.exe";

/**
 * То же для Linux — AppImage: один файл, идёт почти на любом дистрибутиве и
 * обновляется сам. Перед первым запуском ему нужен флаг «исполняемый».
 */
export const DESKTOP_DOWNLOAD_LINUX = "/desktop/electron/Airel.AppImage";
